module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<div class="reports__title">'+
((__t=( obj.title ))==null?'':__t)+
'</div>\n\n				<div class="reports__controls">\n					<div class="reports__period">\n\n							<div class="form-group">\n			            <input type="input" class="form-control js-report-period-field" name="startDate" placeholder="" value="">\n			        </div>\n\n							<div class="reports__period-popup field-popup js-report-period-popup">\n								<div class="field-popup__header">\n									<div class="field-popup__title">Select report period</div>\n								</div>\n								<div class="field-popup__body field-body__region">\n\n									<input type="hidden" name="startDate" class="js-period-input-start"/>\n									<input type="hidden" name="endDate" class="js-period-input-end"/>\n									<div class="range-start js-reports-range-start">\n									</div>\n									<div class="range-end js-reports-range-end">\n									</div>\n								</div>\n								<div class="field-popup__footer">\n									<a class="m-btn m-btn--primary js-report-period-apply">apply</a>\n								</div>\n							</div>\n\n\n\n					</div>\n\n							<div class="reports__resolution">\n									<div class="form-group">\n										<select class="form-control js-report-resolution-select" name="resolution">\n											<option value="hour" ';
 if (obj.resolution === 'hour') { 
__p+='selected';
 } 
__p+='>Hour</option>\n									  	<option value="day" ';
 if (obj.resolution === 'day') { 
__p+='selected';
 } 
__p+='>Day</option>\n									  	<option value="week" ';
 if (obj.resolution === 'week') { 
__p+='selected';
 } 
__p+='>Week</option>\n									  	<option value="month" ';
 if (obj.resolution === 'month') { 
__p+='selected';
 } 
__p+='>Month</option>\n									  </select>\n					        </div>\n\n\n\n							</div>\n							<a class="m-btn m-btn--primary m-btn--client js-export" role="button">export</a>\n\n        </div>\n\n<!-- 				<div class="reports__export"><a class="m-btn m-btn--primary js-add" role="button">export</a></div>\n -->\n\n\n				<div class="reports__data">\n\n					<table>\n						<thead>\n							<th>time</th>\n							<th>avg</th>\n							<th>min</th>\n							<th>max</th>\n							<th>sum</th>\n						</thead>\n						<tbody>\n						';
 if (!obj.hasResults()) { 
__p+='\n						<tr class="m-list-empty"><td colspan="100">\n							<div class="m-list-empty__inner">\n								<div class="empty-indicator">\n						      <div class="empty-indicator__icon"></div>\n									<h2>Whoops! no data.</h2>\n							    <p>no reporting data found for the given criteria</p>\n						      </div>\n						    </div>\n						  </div>\n						</td>\n					</tr>\n					';
 } 
__p+='\n\n					';
 _.each(obj.data, function(row) { 
__p+='\n						<tr>\n							<td>'+
((__t=( formatTime(row.time) ))==null?'':__t)+
'</td>\n							<td>'+
((__t=( formatValue(row.avg) ))==null?'':__t)+
'</td>\n							<td>'+
((__t=( formatValue(row.min) ))==null?'':__t)+
'</td>\n							<td>'+
((__t=( formatValue(row.max) ))==null?'':__t)+
'</td>\n							<td>'+
((__t=( formatValue(row.sum) ))==null?'':__t)+
'</td>\n						</tr>\n					';
 }) 
__p+='\n				</tbody>\n					</table>\n\n				</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/page-reports/list/templates/report-data-layout.html
// module id = 455
// module chunks = 0